export default "__VITE_ASSET__34527fb5__"